import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-home-card',
    templateUrl: './home-card.component.html',
    imports: [MatIcon, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeCardComponent {
  titulo = input.required<string>();
  icone = input.required<string>();
  link = input.required<string[]>();
  texto = input.required<string>();
  textoLink = input.required<string>();
}
